import React from 'react';
import { Select } from 'antd';
import useHotelSelectorHook from './HotelSelector.hook';

const { Option } = Select;

export default function NewHotelSelector({
  mode = 'single',
  fixedHotel = false,
  onHotelSelected,
  enableAllHotels = false,
  autoSelect = false,
  isLoading = false,
  customStyles = {},
  disabled = false,
}) {
  const isMultiple = mode === 'multiple';
  const { state, actions } = useHotelSelectorHook(
    onHotelSelected,
    enableAllHotels,
    autoSelect,
    isMultiple
  );

  return (
    <Select
      mode={isMultiple ? 'multiple' : undefined}
      allowClear={true}
      style={{ width: '100%', ...customStyles }}
      value={
        isMultiple
          ? state.selectedValue.map(v => (v === null ? 'null' : v))
          : state.selectedValue === null
          ? 'null'
          : state.selectedValue
      }
      {...(isMultiple
        ? {
            onSelect: actions.onSelectNewHotel,
            onDeselect: actions.onDeselectNewHotel,
          }
        : {
            onChange: actions.handleChange,
          })}
      optionFilterProp="children"
      disabled={isLoading || disabled}
      placeholder="Select hotel"
    >
      {state.hotelList.map(hotel => (
        <Option
          key={hotel.id === null ? 'null' : hotel.id}
          value={hotel.id === null ? 'null' : hotel.id}
          disabled={hotel.id === fixedHotel || isLoading}
        >
          {hotel.name}
        </Option>
      ))}
    </Select>
  );
}
